import { VisitReportsSuccessAction, VisitReportsRequestAction } from './../../../modules/shared/stores/visitReportsDataStore/visitReportsData.actions';
import { VisitReportsStoreModels } from './../../../modules/shared/stores/visitReportsDataStore/visitReportsData.state';
import { selectorVisitReportsAllData } from './../../../modules/shared/stores/visitReportsDataStore/visitReportsData.selectors';
import { RootReducerState } from './../../../modules/shared/stores/ngrx.imports';
import { Store } from '@ngrx/store';
import { DATE_RANGE_LIST } from './../../../modules/shared/constants/date-range-list.constants';
import { ReportsAllFiltersAppyModels, ReportsAllFiltersApplyModes, typeReportsAllFiltersApplyModes } from './../../models/reports-all-filter-appy.models';
import { VisitReportsFiltersModels } from './../../../models/visit-reports/visit-reports-filters.models';
import { myFavListData } from './../../myfav-data';
import { ReportsMyFavList } from './../../models/reports-myfav-list.model';
import { ReportsVisitsLabelName, ReportsVisitsNames, ReportsVisitsRoutes } from './../../models/reports-visits.enums';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ReportService } from '../../reportService';
import { reportNames } from '../../constants';
import { IReportsFilterModel } from '../../models/reports-filter.models';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { DataService } from '../../dataService';
import { TimeConvertPipe } from 'src/app/modules/shared/pipes/timeConvert.pipe';
import { LocalDatePipe } from 'src/app/shared/pipes/local-date.pipe';
import { DatePipe } from '@angular/common';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as FileSaver from 'file-saver';
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from '../../models/reports-data-service-model';
import { PrintPdfModel } from '../../models/reports-print-pdf-model';
import { IReportsColumnModel } from '../../models/reports.models';
import { getVisitReportsStoredData } from './../../../modules/shared/stores/visitReportsDataStore/visitReportsData.compare';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-reports-visits',
    templateUrl: './reports-visits.component.html',
    styleUrls: ['./reports-visits.component.scss'],
    providers: [LocalDatePipe, TimeConvertPipe, DatePipe]
})
export class ReportsVisitsComponent implements OnInit, OnDestroy, OnChanges {

    @Input() selectedReportFilters: VisitReportsFiltersModels;
    @Input() selectedWindow: string = '';
    @Input() dashboardView: string = "";
    @Input() dateFrom: any;
    @Input() dateTo: any;
    @Input() displayFilterPopup: boolean = false;
    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Input() reloadContent: boolean = false;
    @Output() onReloadContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onLastReloadTime: EventEmitter<any> = new EventEmitter<Date>();
    @Output() onUpdateAllFilters: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();
    reportsFilterApplyMode: typeReportsAllFiltersApplyModes|"" = "";
    reportsDataLoaded: boolean = false;
    filterPopupHeader: string = "Filter";
    loadReportsFirstTime: boolean = false;
    visitReportsLoading: boolean = false;

    //#region Properties
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    public reportName: string = '';
    public reportDate: any;
    public selectedDateFilter: any = null;
    public selectedFilterGroup: IReportsFilterModel[] = [];
    private myFavId: number = 0;
    private myFavList: ReportsMyFavList[] = myFavListData as any;
    private selectedMyFav: ReportsMyFavList = null;

    // selectedDateFilter = { label: 'This Month', code: 'thismonth' };
    // // public selectedTerritoryUser: any = {};
    // public selectedRepFilter = { header: "All", userheader: "All", id: 0 };
    // public selectedDateModuleFilter = { header: 'All', id: 0 };
    // public selectedDateCategoryFilter = { header: 'All', id: 0 };

    public Months: any[] = [];
    public cols: IReportsColumnModel[] = [];
    public reportsData = [];
    public reportsDataCopy = [];
    public filterByInputValue: any[] = [];// available value pass to filter component
    public reportsFlatData = [];// available value pass to table component
    public reportsFlatAllData = [];// available value pass to table component
    public results: any[] = [];
    public noContactFindOrLoadingText = 'Loading....';
    public organizationName = "";
    public isPrint = false;
    public obj: any;
    //field management
    public averageByRepReportDate = this.app._showDateTimeWithZone(new Date());
    //Field Visit History by rep
    public historyByRepReportDate = this.app._showDateTimeWithZone(new Date());
    historyByTerriReportDate = this.app._showDateTimeWithZone(new Date());
    accountVisitReportDate = this.app._showDateTimeWithZone(new Date());

    public stackedBarByRep: any = {
        labels: [],
        datasets: [
            {
                type: 'bar',
                label: 'Visited',
                backgroundColor: '#66BB6A',
                data: []
            }, {
                type: 'bar',
                label: 'Not Visited',
                backgroundColor: '#ecb71c',
                data: []
            }
        ]
    };

    public stackedBarByTerri: any = {
        labels: [],
        datasets: [{
            type: 'bar',
            label: 'Visited',
            backgroundColor: '#66BB6A',
            data: []
        }, {
            type: 'bar',
            label: 'Not Visited',
            backgroundColor: '#ecb71c',
            data: []
        }]
    };

    stackedOptions = {
        tooltips: {
            mode: 'index',
            intersect: false
        },
        responsive: true,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    chartLabel: string = "Geo Matched";

    reportsVisitsNames = ReportsVisitsNames;
    accountsChannelList = [];
    leadsChannelList = [];

    showChannelFilter: boolean = false;
    channelList = [];
    selectedChannel = null;
    //#endregion

    dummyCols = [
        {header:"Name",field:"businessname",},
        {header:"Total Visits",field:"totalvisit",},
        {header:"Geo Matched",field:"visitCount",},
        {header:"Non-Geo Matched",field:"nonvisitedcount",},
        {header:"Last Visit Date",field:"createddate",},
        {header:"Avg. Time spent",field:"timeSpent",},
    ]


    searchControl = new FormControl();
    searchValue: string = "";

    constructor(
        private store: Store<RootReducerState>,
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private router: ActivatedRoute,
        private dataService: DataService,
        public localDatePipe: LocalDatePipe,
        private timeConvertPipe: TimeConvertPipe,
    ) {
        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                if (data.value == ReportsTopMenuItemsValues.print) {
                    this.print();
                }
                else if (data.value == ReportsTopMenuItemsValues.PDF) {
                    this.exportPDF(this.selectedWindow, false);
                }
                else if (data.value == ReportsTopMenuItemsValues.XLS) {
                    this.exportXLS(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                    this.exportXLSX(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.selectedFilterGroup = [];
                    this.fieldVisitReport();
                }
            }
        });
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges){
        if(changes?.selectedWindow?.currentValue){
            this.selectedWindow = changes.selectedWindow.currentValue;
            if(this.loadReportsFirstTime) this.loadChartDataOnly();
        }

        if(changes?.displayFilterPopup){
            this.displayFilterPopup = changes.displayFilterPopup?.currentValue||false;
        }

        if(changes?.reloadContent && changes?.reloadContent?.currentValue){
            this.reloadContent = true;
            this.loadReportsFirstTime = true;
            this.loadChartDataOnly();
        }

        if(changes?.selectedReportFilters && changes?.selectedReportFilters?.currentValue){
            this.selectedReportFilters = changes?.selectedReportFilters?.currentValue;
            if(this.loadReportsFirstTime) this.setSelectedFilters();
        }
    }


    async ngOnInit() {

        !this.dashboardView && this.appMainService.isShowSpinner('channelLoader');
        this.visitReportsLoading = true;
        this.accountsChannelList = await this.dataService.getAccountChannelList();
        this.leadsChannelList = await this.dataService.getLeadChannelList();
        this.appMainService.isHideSpinner('channelLoader');
        this.visitReportsLoading = false;
        this.initSearchReportsData();


        if(this.dashboardView){
            this.loadReportsFirstTime = true;
            this.loadChartDataOnly();
        }else{
            this.router.paramMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((param: any) => {
                const activityType = param.params.type;

                this.showChannelFilter = false;
                this.channelList = [];
                this.selectedChannel = null;

                switch (activityType) {
                    case ReportsVisitsRoutes.avareagefieldvisitbyrep:
                        this.selectedWindow = ReportsVisitsNames.avareagefieldvisitbyrep;
                        this.reportName = ReportsVisitsLabelName.avareagefieldvisitbyrep;
                        break;

                    case ReportsVisitsRoutes.getaccountfieldvisithistorybyrep:
                        this.selectedWindow = ReportsVisitsNames.getaccountfieldvisithistorybyrep;
                        this.reportName = ReportsVisitsLabelName.getaccountfieldvisithistorybyrep;
                        break;
                    case ReportsVisitsRoutes.getleadfieldvisithistorybyrep:
                        this.selectedWindow = ReportsVisitsNames.getleadfieldvisithistorybyrep;
                        this.reportName = ReportsVisitsLabelName.getleadfieldvisithistorybyrep;
                        break;

                    case ReportsVisitsRoutes.getterritorywiseaccountvisithistoryofrep:
                        this.selectedWindow = ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep;
                        this.reportName = ReportsVisitsLabelName.getterritorywiseaccountvisithistoryofrep;
                        break;
                    case ReportsVisitsRoutes.getterritorywiseleadvisithistoryofrep:
                        this.selectedWindow = ReportsVisitsNames.getterritorywiseleadvisithistoryofrep;
                        this.reportName = ReportsVisitsLabelName.getterritorywiseleadvisithistoryofrep;
                        break;

                    case ReportsVisitsRoutes.getterritorywiseaccountvisithistory:
                        this.selectedWindow = ReportsVisitsNames.getterritorywiseaccountvisithistory;
                        this.reportName = ReportsVisitsLabelName.getterritorywiseaccountvisithistory;

                        this.showChannelFilter = true;
                        this.channelList = this.accountsChannelList;
                        this.selectedChannel = this.channelList ? this.channelList.find(el=>el.isDefault==true)||this.channelList[0] : null;
                        break;
                    case ReportsVisitsRoutes.getterritorywiseleadvisithistory:
                        this.selectedWindow = ReportsVisitsNames.getterritorywiseleadvisithistory;
                        this.reportName = ReportsVisitsLabelName.getterritorywiseleadvisithistory;

                        this.showChannelFilter = true;
                        this.channelList = this.leadsChannelList;
                        this.selectedChannel = this.channelList ? this.channelList.find(el=>el.isDefault==true)||this.channelList[0] : null;
                        break;
                    default:
                        break;
                }
                this.cols = [];//clear filter
                this.selectedFilterGroup = [];
                // const selectedUser = this.selectedRepFilter;
                //send to parent for left menu expansion

              this.router.queryParamMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((queryParam: any) => {
                    // console.log(queryParam);
                    const myFavId = parseInt(queryParam.params?.myfav);

                    // console.log(this.accountsChannelList);
                    // console.log(this.leadsChannelList);

                    if(myFavId>0){
                        this.setFVHByRepBarData([], [], []);
                        this.myFavId = myFavId;
                        const selectedMyFav = this.myFavList.find(fav=>fav.id==this.myFavId);
                        const dateFilter = selectedMyFav.filters.find(fav=>fav.columnName=="main_date");

                        const selectedDateFilter = dateFilter ?
                                                 { label: dateFilter.filterValue, code: dateFilter.filterValue, fromDate: dateFilter.fromDate, toDate: dateFilter.toDate }
                                                :{ label: 'Today', code: 'today' };

                        if(JSON.stringify(this.selectedDateFilter)==JSON.stringify(selectedDateFilter) && this.selectedMyFav?.reportType == selectedMyFav.reportType){
                            this.setCustomFilters();
                        }else{
                            this.selectedDateFilter = selectedDateFilter;
                            this.selectedMyFav = selectedMyFav;
                        }
                    }else{
                        this.myFavId = 0;
                        this.selectedDateFilter = { label: 'Today', code: 'today' };
                        this.selectedMyFav = null;
                    }


                });
                //Send To Parent Component For Left Menu Expand
                this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });

            });
        }
    }

    initSearchReportsData() {
        this.searchControl = new FormControl();
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe((value: string) => {
                this.searchValue = value.trim() || '';

                if(this.searchValue && this.reportsFlatAllData?.length>0){
                    this.reportsFlatData = this.reportsFlatAllData.filter(data =>
                        Object.values(data)
                          .some(value => (value && value?.toString()?.toLowerCase().includes(this.searchValue.toLowerCase())))
                      );
                }else{
                    this.reportsFlatData = ParseHelper.DeepCopy(this.reportsFlatAllData);
                }

            });
    }

    loadChartDataOnly(){
        this.cols = [];//clear filter
        this.selectedFilterGroup = [];
        this.reportsData = [];
        this.setSelectedFilters();
        this.setAddedFilters();
        if(!this.selectedReportFilters?.dateFilter){
            this.fieldVisitReport();
        }
    }

    setSelectedFilters(){
        this.selectDefaultChannel(this.selectedReportFilters?.leadChannelId||0,this.selectedReportFilters?.accountChannelId||0)

        if(this.selectedReportFilters?.dateFilter){
            this.selectedDateFilter = {
                label: this.selectedReportFilters.dateFilter,
                code: this.selectedReportFilters.dateFilter,
                fromDate: this.selectedReportFilters?.fromDate||null,
                toDate: this.selectedReportFilters?.toDate||null
            }
        }
    }

    selectDefaultChannel(leadChanneId: number = 0, accountChannelId: number = 0){

        this.showChannelFilter = false;
        this.channelList = [];
        this.selectedChannel = null;

        switch (this.selectedWindow) {
            case ReportsVisitsNames.getterritorywiseaccountvisithistory:
                this.reportName = ReportsVisitsLabelName.getterritorywiseaccountvisithistory;

                this.showChannelFilter = true;
                this.channelList = this.accountsChannelList;

                const channelExist = this.channelList.find(channel=>channel?.id==accountChannelId);

                if(channelExist && accountChannelId){
                    this.selectedChannel = channelExist;
                }else{
                    this.selectedChannel = this.channelList ? this.channelList.find(el=>el.isDefault==true)||this.channelList[0] : null;
                }
                break;
            case ReportsVisitsNames.getterritorywiseleadvisithistory:
                this.reportName = ReportsVisitsLabelName.getterritorywiseleadvisithistory;

                this.showChannelFilter = true;
                this.channelList = this.leadsChannelList;

                const channelExist2 = this.channelList.find(channel=>channel?.id==leadChanneId);

                if(channelExist2 && accountChannelId){
                    this.selectedChannel = channelExist2;
                }else{
                    this.selectedChannel = this.channelList ? this.channelList.find(el=>el.isDefault==true)||this.channelList[0] : null;
                }
                break;
            default:
                break;
        }
    }


    fieldVisitReport(): void {

        const getReportsData = this.store.select(selectorVisitReportsAllData);

        !this.dashboardView && this.appMainService.isShowSpinner('FieldVisitReport');
        this.reportsData = [];
        this.results = [];
        this.organizationName = this.app.user.organizationName;
        this.reportsDataLoaded = false;
        this.visitReportsLoading = true;

        const addedFilters: VisitReportsFiltersModels = {
            dateFilter: this.selectedDateFilter?.code,
            fromDateOnly: this.formatDate(this.dateFrom),
            toDateOnly: this.formatDate(this.dateTo),
            leadChannelId: 0,
            accountChannelId: 0
        }

        switch (this.selectedWindow) {
            case ReportsVisitsNames.getterritorywiseaccountvisithistory:
                addedFilters.accountChannelId = this.selectedChannel?.id||0;
                break;
            case ReportsVisitsNames.getterritorywiseleadvisithistory:
                addedFilters.leadChannelId = this.selectedChannel?.id||0;
                break;
            default:
                break;
        }

        getReportsData.subscribe(storedData=>{
            // console.log(storedData)

            const results = getVisitReportsStoredData(storedData,this.selectedWindow,addedFilters);
            // console.log(results);
            if(results.index > -1 && this.dashboardView!='' && !this.reloadContent && this.reportsFilterApplyMode==""){
                const updatedTime: Date = results?.data?.loadedTime ? new Date( results?.data?.loadedTime) : new Date();
                this.onLastReloadTime.emit(updatedTime);
                this.setReportsResponse(results?.data?.reportsData||[]);
                this.setReportsFinalResponse();
            }else{
                this.reloadContent = false;
                this.loadNewReportsData(addedFilters);
            }

        });

    }

    loadNewReportsData(addedFilters: VisitReportsFiltersModels){
        if(this.dashboardView!='' && this.reportsFilterApplyMode!=ReportsAllFiltersApplyModes.applyOnly){
            this.store.dispatch(new VisitReportsRequestAction());
        }

        if(!this.selectedWindow)return;

        this.reportService.AllFieldVisitReport(this.selectedChannel?.id||0, 0, 0, addedFilters.fromDateOnly,addedFilters.toDateOnly, this.selectedWindow, 0, null, null, null, "").then(res => {

            let { contacts, headers } = res;
            let results = ParseHelper.DeepCopy(contacts);

            const updatedTime: Date = new Date();
            this.onLastReloadTime.emit(updatedTime);
            this.setReportsResponse(results);

            if(this.dashboardView!='' && this.reportsFilterApplyMode!=ReportsAllFiltersApplyModes.applyOnly){
                this.setVisitReportsStoreData(results,addedFilters);
            }

            this.reportsFilterApplyMode = "";

        }).finally(() => {
            this.setReportsFinalResponse();
        });
    }

    setReportsResponse(responseData){

        const territoryReports: any[] = [ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep, ReportsVisitsNames.getterritorywiseleadvisithistoryofrep];
        const statusReports: any[] = [ReportsVisitsNames.getterritorywiseaccountvisithistory,ReportsVisitsNames.getterritorywiseleadvisithistory];
        if(territoryReports.includes(this.selectedWindow)){
            const filterByInputValue = [];
            responseData?.forEach(element => {
                element.reps?.forEach(rep => {
                    if(rep.visits?.length>0)
                        filterByInputValue.push(...rep?.visits?.map(x => { return { ...x.visitdata, username: rep.username, territoryname: element.territoryname }; }));
                });
            });
            responseData = this.formatTerritoryDataAsGroup(filterByInputValue);
        }else if(statusReports.includes(this.selectedWindow)){
            let filterByInputValue = [];
            responseData.map((accountDetails, index)=>{
                const accountData = {
                    id: index+1,
                    ...accountDetails,
                    createddate: null,
                    visitedcount: 0,
                    nonvisitedcount: 0,
                    totalvisit: 0,
                    timespent: 0,
                    visitsdetail: []
                }

                if(accountDetails?.visitdata?.length>0){
                    accountDetails.visitdata.map(visitdata=>{
                        accountData.visitedcount +=visitdata.visitedcount;
                        accountData.nonvisitedcount +=visitdata.nonvisitedcount;
                        accountData.totalvisit +=visitdata.totalvisit;
                        // accountData.timespent +=visitdata.timespent;
                        accountData.visitsdetail = [...accountData.visitsdetail,...visitdata.visitsdetail]
                    })
                }

                if(accountData.visitsdetail?.length>0){
                    accountData.visitsdetail.map(visitdetail=>{
                        accountData.timespent +=visitdetail.timespent;
                    });
                    accountData.timespent = accountData.timespent>0 ? accountData.timespent/accountData.visitsdetail?.length : accountData.timespent;
                }

                if(accountData.visitsdetail.length>0){
                    accountData.visitsdetail = accountData.visitsdetail.sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
                    accountData.createddate = accountData.visitsdetail[0].datetime;
                }

                filterByInputValue.push(accountData);
            })


            let visitedAccounts = filterByInputValue.filter(a=> a?.totalvisit && a?.businessname).sort((a, b) => new Date(b.createddate).getTime() - new Date(a.createddate).getTime());
            // visitedAccounts = this.removeDuplicatesByKey(visitedAccounts,'businessid');
            let nonvisitedAccounts = filterByInputValue.filter(a=> !a?.totalvisit && a?.businessname).sort((a, b) => b.businessid - a.businessid);
            // nonvisitedAccounts = this.removeDuplicatesByKey(nonvisitedAccounts,'businessid');
            responseData = [...visitedAccounts,...nonvisitedAccounts];
        }

        this.reportsData = ParseHelper.DeepCopy(responseData);
        this.reportsDataCopy = ParseHelper.DeepCopy(responseData);
        this.filterByInputValue = ParseHelper.DeepCopy(responseData);

        if(this.myFavId==0){
            if (this.selectedWindow === ReportsVisitsNames.getaccountfieldvisithistorybyrep || this.selectedWindow === ReportsVisitsNames.getleadfieldvisithistorybyrep) {
                this.setChartForFieldVisit(this.reportsData);
            }

            if (this.selectedWindow == ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep || this.selectedWindow == ReportsVisitsNames.getterritorywiseleadvisithistoryofrep) {
                this.setFVHByTerritorryResponse();
            }
        }
        //added for PDF
        this.results = ParseHelper.DeepCopy(responseData);
        //added for PDF

        //set filtered cols
        this.setFilterCols();
        this.setCustomFilters();
        this.reportsDataLoaded = true;
        this.visitReportsLoading = false;
        this.appMainService.isHideSpinner('FieldVisitReport');
    }

    setReportsFinalResponse(){
        this.appMainService.isHideSpinner('FieldVisitReport');
        this.noContactFindOrLoadingText = 'No Reports Available.';
        this.reportsDataLoaded = true;
        this.visitReportsLoading = false;
        this.onReloadContent.emit(false);
    }

    setVisitReportsStoreData(results: any, addedFilters: VisitReportsFiltersModels){
        const reportsData: VisitReportsStoreModels = {
            reportsData: results,
            reportType: this.selectedWindow,
            loadedTime: new Date(),
            addedFilters: addedFilters,
            loading: false,
            loaded: true
        }

        this.store.dispatch(new VisitReportsSuccessAction(reportsData));
    }

    setFVHByTerritorryResponse(): void {
        for (let product of this.reportsData) {
            let allData: { username: '', visitdata: {} }[] = [];
            product.reps = product.reps || [];
            for (let rep of product.reps) {
                for (let el of rep.visits) {
                    rep.visits = rep.visits || [];

                    allData.push({
                        username: rep.username,
                        visitdata: el.visitdata
                    });
                }
            }
            product['allData'] = allData;
        }

        for (let data of this.results) {
            let allData: { username: '', visitdata: {} }[] = [];
            data.reps = data.reps || [];

            for (let rep of data.reps) {
                for (let el of rep.visits) {
                    rep.visits = rep.visits || [];

                    allData.push({
                        username: rep.username,
                        visitdata: el.visitdata
                    });
                }
            }
            data['allData'] = allData;
        }
        this.setChartForFieldVisit(this.reportsData);
    }

    setChartForFieldVisit(products): void {
        if (this.selectedWindow == ReportsVisitsNames.getaccountfieldvisithistorybyrep || this.selectedWindow == ReportsVisitsNames.getleadfieldvisithistorybyrep) {
            this.setFVHByRepData(products);
        } else if (this.selectedWindow == ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep || this.selectedWindow == ReportsVisitsNames.getterritorywiseleadvisithistoryofrep) {
            this.setFVHByTerritorryData(products);
        }
    }

    setFVHByRepData(products): void {
        if (!products || !products.length) {
            this.setFVHByRepBarData([''], [0], [0]);
            this.setFVHByTerritorryBarData([''], [0], [0]);
            return;
        }

        this.setFVHByRepBarData([], [], []);

        const barData = this.stackedBarByRep;

        products.forEach(product => {
            const { username, visits } = product;

            const allVisitedCount = visits ? visits.reduce((sum, data) => data.visitdata.visitedcount + sum, 0) : 0;
            const allNonVisitedCount = visits ? visits.reduce((sum, data) => data.visitdata.nonvisitedcount + sum, 0) : 0;

            barData.labels.push(username || 'N/A');
            barData.datasets[0].data.push(allVisitedCount);
            barData.datasets[1].data.push(allNonVisitedCount);
        });

        this.setFVHByRepBarData(barData.labels, barData.datasets[0].data, barData.datasets[1].data);
    }

    setFVHByRepBarData(labels: string[], visitedData: number[], nonVisitedData: number[]): void {
        this.stackedBarByRep = {
            labels,
            datasets: [
                {
                    type: 'bar',
                    label: 'Visited',
                    backgroundColor: '#66BB6A',
                    data: visitedData
                }, {
                    type: 'bar',
                    label: 'Not Visited',
                    backgroundColor: '#ecb71c',
                    data: nonVisitedData
                }
            ]
        };
    }

    setFVHByTerritorryData(products): void {
        if (!products || !products.length) {
            this.setFVHByTerritorryBarData([''], [0], [0]);
            return;
        }

        this.setFVHByTerritorryBarData([], [], []);

        const barData = this.stackedBarByTerri;

        products.forEach(product => {
            const { territoryname, allData } = product;

            barData.labels.push(territoryname || 'N/A');
            barData.datasets[0].data.push(product?.visitedcount);
            barData.datasets[1].data.push(product?.nonvisitedcount);
        });

        this.setFVHByTerritorryBarData(barData.labels, barData.datasets[0].data, barData.datasets[1].data);
    }

    setFVHByTerritorryBarData(labels: string[], visitedData: number[], nonVisitedData: number[]): void {
        this.stackedBarByTerri = {
            labels,
            datasets: [
                {
                    type: 'bar',
                    label: 'Visited',
                    backgroundColor: '#66BB6A',
                    data: visitedData
                },
                {
                    type: 'bar',
                    label: 'Not Visited',
                    backgroundColor: '#ecb71c',
                    data: nonVisitedData
                }
            ]
        };
    }

    private formatDate(date: Date): any {
        return moment(date).format('MM-DD-YYYY');
    }

    //#region *******Filter Logic******

    setFilterCols(): void {
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case ReportsVisitsNames.avareagefieldvisitbyrep:
                this.cols = [
                    { id: 1, field: 'repName', header: 'Rep Name', dataType: 'string' },
                    { id: 2, field: 'visitCount', header: 'Total Visits', dataType: 'string' },
                    { id: 3, field: 'dayCount', header: 'Day Counts', dataType: 'string' },
                    { id: 4, field: 'averageVisitsPerDay', header: 'Average Visits per day', dataType: 'string' },
                    { id: 5, field: 'createddate', header: 'Last Visit Date', dataType: 'date' },
                    { id: 6, field: 'timeSpent', header: 'Average Time Spent per Account', dataType: 'timespan' },
                ];

                break;
            case ReportsVisitsNames.getaccountfieldvisithistorybyrep:
                this.cols = [
                    { id: 1, field: 'username', header: 'Rep Name', dataType: 'string' },
                    { id: 3, field: 'businessname', header: 'Name', dataType: 'string' },
                    { id: 4, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 9, field: 'businesstypename', header: 'Account Type', dataType: 'string' },
                    { id: 5, field: 'totalvisit', header: 'Total Visits', dataType: 'string' },
                    { id: 6, field: 'visitedcount', header: 'Geo Matched', dataType: 'string' },
                    { id: 7, field: 'nonvisitedcount', header: 'Geo Not Matched', dataType: 'string' },
                    { id: 2, field: 'createddate', header: 'Last Visit Date', dataType: 'date' },
                    { id: 8, field: 'timespent', header: 'Avg. Time Spent', dataType: 'timespan' },
                ];

                break;
            case ReportsVisitsNames.getleadfieldvisithistorybyrep:
                this.cols = [
                    { id: 1, field: 'username', header: 'Rep Name', dataType: 'string' },
                    { id: 3, field: 'businessname', header: 'Name', dataType: 'string' },
                    { id: 4, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 9, field: 'businesstypename', header: 'Lead Type', dataType: 'string' },
                    { id: 5, field: 'totalvisit', header: 'Total Visits', dataType: 'string' },
                    { id: 6, field: 'visitedcount', header: 'Geo Matched', dataType: 'string' },
                    { id: 7, field: 'nonvisitedcount', header: 'Geo Not Matched', dataType: 'string' },
                    { id: 2, field: 'createddate', header: 'Last Visit Date', dataType: 'date' },
                    { id: 8, field: 'timespent', header: 'Avg. Time Spent', dataType: 'timespan' },
                ];
                break;
            case ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep:
                this.cols = [
                    { id: 1, field: 'territoryname', header: 'Territory', dataType: 'string' },
                    { id: 4, field: 'businessname', header: 'Name', dataType: 'string' },
                    { id: 5, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 10, field: 'businesstypename', header: 'Account Type', dataType: 'string' },
                    { id: 11, field: 'territorycontact', header: 'Territory Contact', dataType: 'string' },
                    { id: 6, field: 'totalvisit', header: 'Total Visits', dataType: 'string' },
                    { id: 7, field: 'visitedcount', header: 'Geo Matched', dataType: 'string' },
                    { id: 8, field: 'nonvisitedcount', header: 'Geo Not Matched', dataType: 'string' },
                    { id: 3, field: 'createddate', header: 'Last Visit Date', dataType: 'date' },
                    { id: 9, field: 'timespent', header: 'Avg. Time Spent', dataType: 'timespan' },
                ];
                break;
            case ReportsVisitsNames.getterritorywiseleadvisithistoryofrep:
                this.cols = [
                    { id: 1, field: 'territoryname', header: 'Territory', dataType: 'string' },
                    { id: 4, field: 'businessname', header: 'Name', dataType: 'string' },
                    { id: 5, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 10, field: 'businesstypename', header: 'Lead Type', dataType: 'string' },
                    { id: 11, field: 'territorycontact', header: 'Territory Contact', dataType: 'string' },
                    { id: 6, field: 'totalvisit', header: 'Total Visits', dataType: 'string' },
                    { id: 7, field: 'visitedcount', header: 'Geo Matched', dataType: 'string' },
                    { id: 8, field: 'nonvisitedcount', header: 'Geo Not Matched', dataType: 'string' },
                    { id: 3, field: 'createddate', header: 'Last Visit Date', dataType: 'date' },
                    { id: 9, field: 'timespent', header: 'Avg. Time Spent', dataType: 'timespan' },
                ];
                break;
            case ReportsVisitsNames.getterritorywiseaccountvisithistory:
                this.cols = [
                    { id: 1, field: 'businessname', header: 'Name', dataType: 'string' },
                    { id: 10, field: 'businesstypename', header: 'Account Type', dataType: 'string' },
                    { id: 2, field: 'city', header: 'City', dataType: 'string' },
                    { id: 3, field: 'state', header: 'State', dataType: 'string' },
                    { id: 4, field: 'country', header: 'Country', dataType: 'string' },
                    { id: 5, field: 'totalvisit', header: 'Total Visits', dataType: 'string' },
                    { id: 6, field: 'visitedcount', header: 'Geo Matched', dataType: 'string' },
                    { id: 7, field: 'nonvisitedcount', header: 'Geo Not Matched', dataType: 'string' },
                    { id: 8, field: 'createddate', header: 'Last Visit Date', dataType: 'date' },
                    { id: 9, field: 'timespent', header: 'Avg. Time Spent', dataType: 'timespan' },
                ];

                break;
            case ReportsVisitsNames.getterritorywiseleadvisithistory:
                this.cols = [
                    { id: 1, field: 'businessname', header: 'Name', dataType: 'string' },
                    { id: 10, field: 'businesstypename', header: 'Lead Type', dataType: 'string' },
                    { id: 2, field: 'city', header: 'City', dataType: 'string' },
                    { id: 3, field: 'state', header: 'State', dataType: 'string' },
                    { id: 4, field: 'country', header: 'Country', dataType: 'string' },
                    { id: 5, field: 'totalvisit', header: 'Total Visits', dataType: 'string' },
                    { id: 6, field: 'visitedcount', header: 'Geo Matched', dataType: 'string' },
                    { id: 7, field: 'nonvisitedcount', header: 'Geo Not Matched', dataType: 'string' },
                    { id: 8, field: 'createddate', header: 'Last Visit Date', dataType: 'date' },
                    { id: 9, field: 'timespent', header: 'Avg. Time Spent', dataType: 'timespan' },
                ];

                break;
            default:
                this.cols = [];
                break;
        }
        //set filter value
        this.setFilterValues();
    }

    setFilterValues(): void {
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case ReportsVisitsNames.avareagefieldvisitbyrep:
                this.reportsData?.map(element => {
                    if(element?.visitsDetail?.length>0){
                        element.visitsDetail = element?.visitsDetail.sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
                        element.createddate = element.visitsDetail?.[0]?.datetime;
                    }
                });
                this.filterByInputValue = [...this.reportsData];
                this.reportsFlatData = ParseHelper.DeepCopy(this.filterByInputValue);
                break;
            case ReportsVisitsNames.getaccountfieldvisithistorybyrep:
            case ReportsVisitsNames.getleadfieldvisithistorybyrep:
                this.reportsData?.forEach(element => {
                    if(element.visits?.length>0)
                    this.filterByInputValue.push(...element?.visits?.map(x => { return { ...x.visitdata, username: element.username }; }));
                });
                this.reportsFlatData = ParseHelper.DeepCopy(this.filterByInputValue);
                break;
            case ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep:
            case ReportsVisitsNames.getterritorywiseleadvisithistoryofrep:
                let reportsFlatData = [];
                this.reportsData?.forEach(element => {
                    const territoryList = [element, ...element.accountsList];
                    reportsFlatData = [...reportsFlatData,...territoryList];

                    let accountsList = ParseHelper.DeepCopy(element.accountsList);
                    accountsList = accountsList.map(x=> {
                        return {...x, territoryname: element.territoryname}
                    })
                    this.filterByInputValue = [...this.filterByInputValue,...accountsList];
                });
                this.reportsFlatData = ParseHelper.DeepCopy(reportsFlatData);
                break;
            case ReportsVisitsNames.getterritorywiseaccountvisithistory:
            case ReportsVisitsNames.getterritorywiseleadvisithistory:
                this.filterByInputValue = ParseHelper.DeepCopy(this.reportsData)
                this.reportsFlatData = ParseHelper.DeepCopy(this.filterByInputValue);
                break;
            default:
                break;
        }

        this.reportsFlatAllData = ParseHelper.DeepCopy(this.reportsFlatData);
    }

    removeDuplicatesByKey(list: any[], key: string) {
        const seen = new Set();
        return list.filter(item => {
            const isDuplicate = seen.has(item[key]);
            seen.add(item[key]);
            return !isDuplicate;
        });
    };

    setCustomFilters(){
        const selectedFilters = this.myFavList.find(fav=>fav.id==this.myFavId);

        if(selectedFilters){
            this.selectedFilterGroup = [];

            this.appMainService.isShowSpinner('ReportFavFilters');
            selectedFilters.filters.map((favFilters, index)=>{
                if(favFilters.columnName=="main_date"){
                    //this.selectedDateFilter = {label: favFilters.filterValue,code: favFilters.filterValue};
                }else{
                    const selectedColumn = this.cols.find(col=>col.field==favFilters.columnName);

                    if(selectedColumn){
                        const filterGroup: IReportsFilterModel = {
                            id: index,
                            field: selectedColumn.field,
                            categoryId: selectedColumn.id,
                            category: selectedColumn.header,
                            nameId: selectedColumn.id+"",
                            notRemovable: false,
                            value: favFilters.filterValue,
                            previewValue: favFilters.filterValue,
                            dataType: selectedColumn.dataType
                        }

                        this.selectedFilterGroup.push(filterGroup);
                    }

                }
            });

            this.onApplyFilter(this.selectedWindow,this.selectedFilterGroup);
            this.appMainService.isHideSpinner('ReportFavFilters');
        }
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }

    onClosePanel(selectedWindow: string): void {
    }
    //when apply any filter
    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.reportsData = ParseHelper.DeepCopy(this.reportsDataCopy);
        switch (this.selectedWindow) {
            case ReportsVisitsNames.avareagefieldvisitbyrep:
                //filter table
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        if (filt.dataType == 'date') {
                            this.reportsData = this.reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                        }
                        else {
                            this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }
                    });
                }

                break;
            case ReportsVisitsNames.getaccountfieldvisithistorybyrep:
            case ReportsVisitsNames.getleadfieldvisithistorybyrep:
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        if (filt.field == "username") {
                            this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }
                        else {
                            this.reportsData?.forEach(element => {
                                if (filt.dataType == 'date') {
                                    element.visits = element?.visits.filter(x => this.localDatePipe.transform(x.visitdata[filt.field], 'MM/DD/YYYY') == filt.value);
                                }
                                else {
                                    element.visits = element?.visits.filter(x => x.visitdata[filt.field] == filt.value);
                                }
                            });
                        }
                    });
                }

                break;
            case ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep:
            case ReportsVisitsNames.getterritorywiseleadvisithistoryofrep:
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        //filter by territoryname
                        if (filt.field == "territoryname") {
                            this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }else {
                            this.reportsData?.forEach((element) => {
                                if (filt.dataType == 'date') {
                                    element.accountsList = element.accountsList.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                                }
                                else {
                                    element.accountsList = element.accountsList.filter(x => x[filt.field] == filt.value) ?? [];
                                }
                            });
                        }
                    });
                    //filter 0 counts reps and visits
                    this.reportsData = this.reportsData?.filter(x => x?.accountsList?.length > 0) ?? this.reportsData;
                }

                break;
            case ReportsVisitsNames.getterritorywiseaccountvisithistory:
            case ReportsVisitsNames.getterritorywiseleadvisithistory:
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        if (filt.dataType == 'date') {
                            this.reportsData = this.reportsData.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value);
                        }
                        else {
                            this.reportsData = this.reportsData.filter(x => x[filt.field] == filt.value);
                        }
                    });
                }

                break;
            default:
                break;
        }
        //set value for filter
        this.setFilterValues();
        if (this.selectedWindow === ReportsVisitsNames.getaccountfieldvisithistorybyrep || this.selectedWindow === ReportsVisitsNames.getleadfieldvisithistorybyrep) {
            this.setChartForFieldVisit(this.reportsData);
        }

        if (this.selectedWindow == ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep || this.selectedWindow == ReportsVisitsNames.getterritorywiseleadvisithistoryofrep) {
            this.setFVHByTerritorryResponse();
        }
    }

    //when Edit applied filter
    onModifyFilterOptions(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        let reportData = ParseHelper.DeepCopy(this.reportsDataCopy);
        switch (this.selectedWindow) {
            case ReportsVisitsNames.avareagefieldvisitbyrep:
                //filter table
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        if (filt.dataType == 'date') {
                            reportData = reportData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                        }
                        else {
                            reportData = reportData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }
                    });
                }
                //set value for filter
                this.filterByInputValue = [...reportData];
                break;
            case ReportsVisitsNames.getaccountfieldvisithistorybyrep:
            case ReportsVisitsNames.getleadfieldvisithistorybyrep:
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        if (filt.field == "username") {
                            reportData = reportData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }
                        else {
                            reportData?.forEach(element => {
                                if (filt.dataType == 'date') {
                                    element.visits = element.visits.filter(x => this.localDatePipe.transform(x.visitdata[filt.field], 'MM/DD/YYYY') == filt.value);
                                }
                                else {
                                    element.visits = element.visits.filter(x => x.visitdata[filt.field] == filt.value);
                                }
                            });
                        }
                    });
                }
                //set value for filter
                reportData?.forEach(element => {
                    this.filterByInputValue.push(...element.visits.map(x => { return { ...x.visitdata, username: element.username }; }));
                });
                break;
            case ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep:
            case ReportsVisitsNames.getterritorywiseleadvisithistoryofrep:
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        //filter by territoryname
                        if (filt.field == "territoryname") {
                            reportData = reportData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }else {
                            reportData?.forEach((element) => {
                                if (filt.dataType == 'date') {
                                    element.accountsList = element.accountsList.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                                }
                                else {
                                    element.accountsList = element.accountsList.filter(x => x[filt.field] == filt.value) ?? [];
                                }
                            });
                        }
                    });
                    //remove 0 counts reps and visits
                    reportData = reportData?.filter(x => x?.accountsList?.length > 0) ?? reportData;
                }
                //set value for filter
                reportData?.forEach(element => {
                    let accountsList = ParseHelper.DeepCopy(element.accountsList);
                    accountsList = accountsList.map(x=> {
                        return {...x, territoryname: element.territoryname}
                    })
                    this.filterByInputValue = [...this.filterByInputValue,...accountsList];
                });
                break;
            case ReportsVisitsNames.getterritorywiseaccountvisithistory:
            case ReportsVisitsNames.getterritorywiseleadvisithistory:
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        if (filt.dataType == 'date') {
                            reportData = reportData.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value);
                        }
                        else {
                            reportData = reportData.filter(x => x[filt.field] == filt.value);
                        }
                    });
                }
                this.filterByInputValue = ParseHelper.DeepCopy(reportData);
                break;
            default:
                break;
        }
    }
    //When date filter dropdown change
    onChangeRange(selectedWindow: string, event: { dateFrom: any, dateTo: any }): void {
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        this.fieldVisitReport();
    }

    onChangeChannel(selectedChannel){
        this.selectedChannel = selectedChannel;
        this.fieldVisitReport();
    }
    //#endregion

    //#region Print, PDF, XLSX

    print() {
        this.appMainService.isShowSpinner('Print');
        this.exportPDF(this.selectedWindow, true);
        this.appMainService.isHideSpinner('Print');
    }

    exportPDF(selectedWindow: string, isPrintFlag = false) {
        this.PDFFieldVisitReport(selectedWindow, isPrintFlag, "NoExcel");
    }

    exportXLS(selectedWindow: string) {
        this.PDFFieldVisitReport(selectedWindow, false, "exportXLSX");
    }

    exportXLSX(selectedWindow: string) {
        this.PDFFieldVisitReport(selectedWindow, false, "exportXLSX");
    }

    PDFFieldVisitReport(selectedWindow: string, isPrintFlag: boolean, isexportXLS: string) {
        this.appMainService.isShowSpinner('FieldVisitReport');
        this.organizationName = this.app.user.organizationName;
        this.results = [];
        let contacts = ParseHelper.DeepCopy(this.reportsData);
        this.appMainService.isHideSpinner('FieldVisitReport');
        this.results = JSON.parse(JSON.stringify(contacts));
        if (this.selectedWindow == ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep || this.selectedWindow == ReportsVisitsNames.getterritorywiseleadvisithistoryofrep ||
            this.selectedWindow == ReportsVisitsNames.getterritorywiseaccountvisithistory || this.selectedWindow == ReportsVisitsNames.getterritorywiseleadvisithistory) {
            this.setFVHByTerritorryResponse();
        }
        this.appMainService.isHideSpinner('FieldVisitReport');

        if (isexportXLS === "exportXLS" || isexportXLS === "exportXLSX") {
            let thisdata = [];
            let dataResult = [];
            switch (this.selectedWindow) {
                case ReportsVisitsNames.avareagefieldvisitbyrep: {
                    for (let data of this.results) {
                        this.obj = {
                            'Rep Name': data['repName'],
                            'Total Visits': data['visitCount'],
                            'Day Counts': data['dayCount'],
                            'Average Visits per day': data['averageVisitsPerDay'],
                            'Last Visit Date': this.localDatePipe.transform(data['createddate'], 'MM/DD/YYYY'),
                            'Average Time Spent per Account': this.timeConvertPipe.transform(data['timeSpent']),
                        };
                        dataResult.push(this.obj);
                    }
                    break;
                }
                case ReportsVisitsNames.getaccountfieldvisithistorybyrep:
                case ReportsVisitsNames.getleadfieldvisithistorybyrep:
                    {
                        this.results = this.results || [];

                        for (let data of this.results) {
                            /*this.obj = {
                                'Date': data['username'],
                                'Name': '',
                                'Channel Name': '',
                                'Total Visits': '',
                                'Visited Count': '',
                                'Non Visited Count': '',
                                'Time Spent': '',
                            };

                            dataResult.push(this.obj);*/
                            data.visits = data.visits || [];
                            for (let visit of data.visits) {
                                this.obj = {
                                    'Rep Name': data['username'],
                                    'Name': visit.visitdata['businessname'],
                                    'Channel Name': visit.visitdata['channelname'],
                                    'Total Visits': visit.visitdata['totalvisit'],
                                    'Visited Count': visit.visitdata['visitedcount'],
                                    'Non Visited Count': visit.visitdata['nonvisitedcount'],
                                    'Last Visit Date': this.localDatePipe.transform(visit.visitdata['createddate'], 'MM/DD/YYYY'),
                                    'Avg. Time Spent': this.timeConvertPipe.transform(visit.visitdata['timespent']),
                                };

                                dataResult.push(this.obj);
                            }
                        }

                        break;
                    }
                case ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep:
                case ReportsVisitsNames.getterritorywiseleadvisithistoryofrep:
                case ReportsVisitsNames.getterritorywiseaccountvisithistory:
                case ReportsVisitsNames.getterritorywiseleadvisithistory:
                    {
                        this.results = this.reportsFlatData || [];
                        this.results.map(elem=>{
                            const obj = {};
                            this.cols.map(col=>{
                                obj[col.header] = elem[col.field];

                                if(col.dataType=='date'){
                                    obj[col.header] = this.localDatePipe.transform(elem[col.field], 'MM/DD/YYYY');
                                }else if(col.dataType=='timespan'){
                                    obj[col.header] = this.timeConvertPipe.transform(elem[col.field]);
                                }
                            });

                            dataResult.push(obj);
                        });

                        break;
                    }
                default: {
                    break;
                }
            }

            for (let a2 of dataResult) {
                thisdata.push(a2);
            }

            if (isexportXLS === "exportXLSX") {
                import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(thisdata);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                    const fileName = this.selectedChannel ? `${this.reportName} (${this.selectedChannel?.name})` : this.reportName;
                    this.saveAsExcelFilexlsx(excelBuffer, fileName);
                });
            }

            if (isexportXLS === "exportXLS") {
                import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(thisdata);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
                    const fileName = this.selectedChannel ? `${this.reportName} (${this.selectedChannel?.name})` : this.reportName;
                    this.saveAsExcelFilexls(excelBuffer, fileName);
                });
            }
        }
        else {
            let dataResult1 = [];
            let pdfcolumns = [];
            switch (this.selectedWindow) {
                case ReportsVisitsNames.avareagefieldvisitbyrep: {
                    pdfcolumns = [
                        { dataKey: 'repName', header: 'Rep Name' },
                        { dataKey: 'visitCount', header: 'Total Visits' },
                        { dataKey: 'dayCount', header: 'Day Counts' },
                        { dataKey: 'averageVisitsPerDay', header: 'Average Visits per day' },
                        { dataKey: 'createddate', header: 'Last Visit Date' },
                        { dataKey: 'timeSpent', header: 'Average Time Spent per Account' },
                    ];
                    for (let data of this.results) {
                        this.obj = {
                            'repName': data['repName'],
                            'visitCount': data['visitCount'],
                            'dayCount': data['dayCount'],
                            'averageVisitsPerDay': data['averageVisitsPerDay'],
                            'createddate': this.localDatePipe.transform(data['createddate'], 'MM/DD/YYYY'),
                            'timeSpent': this.timeConvertPipe.transform(data['timeSpent']),
                        };

                        dataResult1.push(this.obj);
                    }
                    this.results = dataResult1;
                    break;
                }
                case ReportsVisitsNames.getaccountfieldvisithistorybyrep:
                case ReportsVisitsNames.getleadfieldvisithistorybyrep:
                    {
                        pdfcolumns = [
                            { dataKey: 'username', header: 'Rep Name' },
                            { dataKey: 'businessname', header: 'Name' },
                            { dataKey: 'channelname', header: 'Channel Name' },
                            { dataKey: 'totalvisit', header: 'Total Visits' },
                            { dataKey: 'visitedcount', header: 'Visited Count' },
                            { dataKey: 'nonvisitedcount', header: 'Non Visited Count' },
                            { dataKey: 'createddate', header: 'Last Visit Date' },
                            { dataKey: 'timespent', header: 'Avg. Time Spent' },
                        ];
                        this.results = this.results || [];
                        for (let data of this.results) {
                            /*this.obj = {
                                'createddate': data['username'],
                                'businessname': '',
                                'channelname': '',
                                'totalvisit': '',
                                'visitedcount': '',
                                'nonvisitedcount': '',
                                'timespent': '',
                            };
                            dataResult1.push(this.obj);*/
                            data.visits = data.visits || [];
                            for (let visit of data.visits) {
                                this.obj = {
                                    'username': data['username'],
                                    'createddate': this.localDatePipe.transform(visit.visitdata['createddate'], 'MM/DD/YYYY'),
                                    'businessname': visit.visitdata['businessname'],
                                    'channelname': visit.visitdata['channelname'],
                                    'totalvisit': visit.visitdata['totalvisit'],
                                    'visitedcount': visit.visitdata['visitedcount'],
                                    'nonvisitedcount': visit.visitdata['nonvisitedcount'],
                                    'timespent': this.timeConvertPipe.transform(visit.visitdata['timespent']),
                                };

                                dataResult1.push(this.obj);
                            }
                        }
                        this.results = dataResult1;
                        break;
                    }
                case ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep:
                case ReportsVisitsNames.getterritorywiseleadvisithistoryofrep:
                case ReportsVisitsNames.getterritorywiseaccountvisithistory:
                case ReportsVisitsNames.getterritorywiseleadvisithistory: {
                    pdfcolumns = this.cols.map(col=>{ return {dataKey: col.field, header: col.header }});

                    this.results = this.reportsFlatData || [];
                    this.results.map(elem=>{
                        const obj = {};
                        this.cols.map(col=>{
                            obj[col.field] = elem[col.field];

                            if(col.dataType=='date'){
                                obj[col.field] = this.localDatePipe.transform(elem[col.field], 'MM/DD/YYYY');
                            }else if(col.dataType=='timespan'){
                                obj[col.field] = this.timeConvertPipe.transform(elem[col.field]);
                            }
                        });

                        dataResult1.push(obj);
                    })
                    this.results = dataResult1;
                    break;
                }
                default: {
                    break;
                }
            }
            const fileName = this.selectedChannel ? `${this.reportName} (${this.selectedChannel?.name})` : this.reportName;
            let options: PrintPdfModel.IPrintPdfOptions = new PrintPdfModel.PrintPdfOptions();
            // let doc = new jsPDF('l', 'mm', [900, 900]);
            let doc = new jsPDF(options.orientation, options.unit, options.format);

            doc.setFontSize(options.organizationName.fontSize);
            doc.text(this.organizationName, options.organizationName.x, options.organizationName.y);

            doc.setFontSize(options.dateFromTo.fontSize);
            let dateFrom = new Date(this.dateFrom);
            let dateTo = new Date(this.dateTo);
            let fdate = ((dateFrom.getMonth() > 8) ? (dateFrom.getMonth() + 1) : ('0' + (dateFrom.getMonth() + 1))) + '/' + ((dateFrom.getDate() > 9) ? dateFrom.getDate() : ('0' + dateFrom.getDate())) + '/' + dateFrom.getFullYear();
            let tdate = ((dateTo.getMonth() > 8) ? (dateTo.getMonth() + 1) : ('0' + (dateTo.getMonth() + 1))) + '/' + ((dateTo.getDate() > 9) ? dateTo.getDate() : ('0' + dateTo.getDate())) + '/' + dateTo.getFullYear();

            !fdate.includes('NaN') && !tdate.includes('NaN') && doc.text(fdate + '  -  ' + tdate, options.dateFromTo.x, options.dateFromTo.y, { align: options.dateFromTo.align });

            doc.setFontSize(options.reportName.fontSize);
            doc.text(fileName, options.reportName.x, options.reportName.y, { align: options.reportName.align });


            autoTable(doc, {
                theme: options.autoTable.theme,
                startY: options.autoTable.startY,
                body: this.results?.length > 0 ? this.results : [], //dataResult,
                columns: this.results?.length > 0 ? pdfcolumns : ["No Reports Available."],
                showHead: options.autoTable.showHead,
                styles: {
                    minCellHeight: options.autoTable.styles.minCellHeight
                }
                // pageBreak : 'always'
            })

            if (isPrintFlag) {
                window.open(URL.createObjectURL(doc.output("blob")))
            }
            else {
                this.saveAsPdfFile(doc, fileName);
            }
            this.appMainService.isHideSpinner('FieldVisitReport');
            this.noContactFindOrLoadingText = 'No Reports Available.';
        }
    }
    saveAsExcelFilexls(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xls';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    saveAsExcelFilexlsx(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

    private saveAsPdfFile(buffer: any, fileName: string): void {
        buffer.save(fileName + '.pdf');
    }

    //#endregion

    closeFilterPopup(){
        this.displayFilterPopup = false;
        this.onCloseFilterPopup.emit(false);
    }

    setAddedFilters(){
        const addedDateRange = DATE_RANGE_LIST.find(range=>range.code==this.selectedReportFilters.dateFilter);
        const filterValues: ReportsAllFiltersAppyModels = {
            applyMode: ReportsAllFiltersApplyModes.applyOnly,
            dateFilter: {
                ...addedDateRange,
                fromDate: this.dateFrom,
                toDate: this.dateTo
            }
        }

        switch (this.selectedWindow) {
            case ReportsVisitsNames.getterritorywiseaccountvisithistory:
                filterValues.accountChannel =  this.selectedChannel;
                break;
            case ReportsVisitsNames.getterritorywiseleadvisithistory:

                filterValues.leadChannel =  this.selectedChannel;
                break;
            default:
                break;
        }

        this.onUpdateAllFilters.emit(filterValues);
    }

    allFiltersChanges(filterValues: ReportsAllFiltersAppyModels){
        this.reportsFilterApplyMode = filterValues.applyMode;
        this.dateFrom = filterValues?.dateFilter?.fromDate || this.dateFrom;
        this.dateTo = filterValues?.dateFilter?.toDate || this.dateTo;
        this.selectedChannel = filterValues?.channel || this.selectedChannel;

        switch (this.selectedWindow) {
            case ReportsVisitsNames.getterritorywiseaccountvisithistory:
                filterValues.accountChannel =  this.selectedChannel;
                break;
            case ReportsVisitsNames.getterritorywiseleadvisithistory:

                filterValues.leadChannel =  this.selectedChannel;
                break;
            default:
                break;
        }

        this.fieldVisitReport();

        this.onUpdateAllFilters.emit(filterValues)
    }

    formatTerritoryDataAsGroup(reportsFlatData: any[]){
        let territoryResults: any[] = [];
        const territoryGroupData = reportsFlatData?.length>0 ? this.groupByTerritoryAndUsername(reportsFlatData) : {};
        Object.keys(territoryGroupData).map(territoryName=>{
            const territoryDetails = territoryGroupData[territoryName];
            let accountsList: any[] = [];
            let territoryTimeSpent: number = 0;
            let territoryLastVisit: string|null = null;

            Object.keys(territoryDetails.accounts).map(businessname=>{
                const accountDetails = territoryDetails.accounts[businessname];
                accountDetails.visitsdetail = accountDetails.visitsdetail.sort((a, b)=> new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
                const lastVist = accountDetails.visitsdetail?.[0]?.datetime||null;
                accountDetails.visitsdetail = accountDetails.visitsdetail.sort((a, b)=> a.username - b.username);
                territoryTimeSpent += accountDetails.timespent;
                territoryLastVisit = (!territoryLastVisit || (new Date(territoryLastVisit).getTime() < new Date(lastVist).getTime())) ? lastVist : territoryLastVisit;
                accountsList.push({
                    rowColor: 'child-color1',
                    businessname: businessname,
                    storeterritoryname: territoryName,
                    channelname: accountDetails.channelname,
                    visitedcount: accountDetails.visitedcount,
                    businesstypename: accountDetails?.businesstypename,
                    territorycontact: "",
                    nonvisitedcount: accountDetails.nonvisitedcount,
                    totalvisit: accountDetails.totalvisit,
                    timespent: (accountDetails.timespent / accountDetails.totalvisit),
                    createddate: lastVist,
                    visitsdetail: accountDetails.visitsdetail
                })
            });
            accountsList = accountsList.sort((a, b)=> a.businessname - b.businessname);
            territoryResults.push({
                rowColor: 'child-color2 p-text-bold',
                territoryname: territoryName,
                storeterritoryname: territoryName,
                territorycontact: territoryDetails?.territorycontact,
                visitedcount: territoryDetails.visitedcount,
                nonvisitedcount: territoryDetails.nonvisitedcount,
                totalvisit: territoryDetails.totalvisit,
                timespent: (territoryTimeSpent / territoryDetails.totalvisit),
                createddate: territoryLastVisit,
                accountsList: accountsList
            });
        });

        return territoryResults;
    }

    groupByTerritoryAndUsername(data: any[]) {
        return data.reduce((acc, curr) => {
            const { territoryname, businessname, territorycontact, channelname, visitedcount, nonvisitedcount, totalvisit, timespent, visitsdetail, username } = curr;
            visitsdetail.map(visit=>{
                visit['username'] = username;
                visit['businessname'] = businessname;
            })
            // If the territory doesn't exist yet, initialize it
            if (!acc[territoryname]) {
                acc[territoryname] = {
                    accounts: {},
                    territorycontact: territorycontact,
                    visitedcount: 0,
                    nonvisitedcount: 0,
                    totalvisit: 0,
                };
            }

            // If the username doesn't exist under this territory, initialize it
            if (!acc[territoryname].accounts[businessname]) {
                acc[territoryname].accounts[businessname] = {
                    ...curr,
                    userDetails: [],
                    channelname: channelname,
                    visitedcount: 0,
                    nonvisitedcount: 0,
                    totalvisit: 0,
                    timespent: 0,
                    visitsdetail: []
                };
            }

            // Add the current user's visit details to their specific username entry
            // acc[territoryname].accounts[businessname].userDetails.push(curr);

            // Add the counts to the user's totals
            acc[territoryname].accounts[businessname].visitedcount += visitedcount;
            acc[territoryname].accounts[businessname].nonvisitedcount += nonvisitedcount;
            acc[territoryname].accounts[businessname].totalvisit += totalvisit;
            acc[territoryname].accounts[businessname].timespent += (totalvisit*timespent);
            acc[territoryname].accounts[businessname].visitsdetail = [...acc[territoryname].accounts[businessname].visitsdetail,...visitsdetail];

            // Add the counts to the territory's totals
            acc[territoryname].visitedcount += visitedcount;
            acc[territoryname].nonvisitedcount += nonvisitedcount;
            acc[territoryname].totalvisit += totalvisit;

            return acc;
        }, {});
    }
}
